function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgColorButtonGradient = function SvgColorButtonGradient(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 100,
    viewBox: "0 0 1280 100"
  }, props), h("defs", null, h("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y1: 0.089,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, h("stop", {
    offset: 0,
    stopOpacity: 0
  }), h("stop", {
    offset: 0.626,
    stopOpacity: 0.757
  }), h("stop", {
    offset: 1
  }))), h("path", {
    fill: "url(#a)",
    d: "M0 0h1280v100H0z"
  }), h("text", {
    fill: "#fff",
    "data-name": "FREEVIEW TV GUIDE",
    fontFamily: "Barlow-Medium, Barlow",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(1053 63)"
  }, h("tspan", {
    x: 0,
    y: 0
  }, "FREEVIEW TV GUIDE")), h("path", {
    fill: "#8cc63e",
    d: "M1036 50a7 7 0 1 1-7 7 7 7 0 0 1 7-7",
    "data-name": "Path 103"
  }), h("g", {
    "data-name": "HBBTV-Nav-Item",
    transform: "translate(948 45)"
  }, h("text", {
    fill: "#fff",
    fontFamily: "Barlow-Medium, Barlow",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(24 18)"
  }, h("tspan", {
    x: 0,
    y: 0
  }, "EXIT")), h("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#f23436",
    "data-name": "Ellipse 17",
    transform: "translate(0 5)"
  })));
};
export default SvgColorButtonGradient;